import { observable, action } from "mobx";
import { createContext, useContext } from "react";

export type ErrorModalContent = {
  title: string;
  message: string;
  cta: string;
};

export class ErrorModalStore {
  @observable
  show = false;

  @observable
  retryCta: any;

  @observable
  content?: ErrorModalContent;

  @action
  showAlert(content?: ErrorModalContent) {
    this.content = content;
    this.show = true;
  }

  @action
  hideAlert() {
    this.show = false;
  }

  onClick() {
    this.hideAlert();
    this.retryCta?.();
  }
}

export const ErrorModalStoreContext = createContext(new ErrorModalStore());

export const useErrorModalStore = () => useContext(ErrorModalStoreContext);
